import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useMsal } from "@azure/msal-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import envConfig from "../../../config/config";

const AddComponentForm = ({ isOpen, setIsOpen, flagVal }) => {
    const { accounts } = useMsal();
    const userEmail = accounts[0]?.username.toLowerCase() || "";
    const userName = accounts[0]?.name || "";
    console.log(userEmail);


    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: { errors },
    } = useForm();

    const category = watch("category");

    const closePopup = () => {
        reset();
        setIsOpen(false);
    };

    const onSubmit = async (data) => {
        const payload = {
            ComponentName: data.componentName,
            ComponentDetails: data.componentDetails,
            Technology: data.technology,
            Category: data.category === "Others" ? data.customCategory : data.category,
            OtherCategory: data.category === "Others" ? data.customCategory : "", // Ensure it is always sent
            ProjectName: data.projectName,
            ProjectDetails: data.projectDetails,
            CustomerName: data.customerName,
            SenderName: userName,
            SenderEmail: userEmail.toLowerCase(),
            FlagValue: flagVal,
            ComponentType:"New"
        };

        try {
            const response = await fetch(envConfig.REACT_APP_UIREPO+"/api/request/",{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error("Failed to submit form");
            }

            toast.success("Component submitted successfully!");
            reset();
            closePopup();
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("Failed to submit. Please try again.");
        }
    };


    useEffect(() => {
        if (userEmail) {
            fetch(`https://prod.appstudioltts.com/api/empdata/employees/${userEmail}`)
                .then((res) => res.json())
                .then((data) => {
                    if (data?.name) {
                        setValue("customerName", data.name);
                    }
                })
                .catch((err) => console.error("Error fetching user data:", err));
        }
    }, [userEmail, setValue]);

    if (!isOpen) return null;

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} /> {/* Ensure ToastContainer is always rendered */}
            <div className="fixed top-0 left-1/2 transform -translate-x-1/2 z-50 bg-black bg-opacity-50 w-full h-full overflow-auto pt-10 px-4">
                <div className="flex justify-center h-full items-center">
                    <div className="bg-white rounded-2xl shadow-lg w-full  max-w-2xl p-6 relative">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-semibold">Add New Component</h2>
                            <button
                                onClick={closePopup}
                                className="text-gray-600 hover:text-red-600 text-2xl font-bold"
                            >
                                &times;
                            </button>
                        </div>
                        <div className="max-h-[400px] overflow-auto">
                            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 ">
                                {/* Component Name */}
                                <div>
                                    <label className="block text-sm font-medium">
                                        Component Name<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        {...register("componentName", { required: "Component Name is required" })}
                                        placeholder="Enter Component Name..."
                                        className="mt-1 w-[98%] text-sm border rounded p-2 focus:outline-none "
                                    />
                                    {errors.componentName && (
                                        <p className="text-sm text-red-500">{errors.componentName.message}</p>
                                    )}
                                </div>

                                {/* Component Details */}
                                <div>
                                    <label className="block text-sm font-medium">
                                        Component Details<span className="text-red-500">*</span>
                                    </label>
                                    <textarea
                                        {...register("componentDetails", { required: "Component Details are required" })}
                                        placeholder="Enter Component Details..."
                                        className="mt-1 w-[98%] text-sm border rounded p-2 h-20 resize-none focus:outline-none "
                                    />
                                    {errors.componentDetails && (
                                        <p className="text-sm text-red-500">{errors.componentDetails.message}</p>
                                    )}
                                </div>

                                {/* Technology */}
                                <div>
                                    <label className="block text-sm font-medium">
                                        Select Technology<span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        {...register("technology", { required: "Technology selection is required" })}
                                        className="mt-1 w-[98%] text-sm border rounded p-2 focus:outline-none "
                                    >
                                        <option value="">Choose Technology...</option>
                                        <option value="React">React</option>
                                        <option value="Angular">Angular</option>
                                        <option value="Angular,React">Angular,React</option>
                                    </select>
                                    {errors.technology && (
                                        <p className="text-sm text-red-500">{errors.technology.message}</p>
                                    )}
                                </div>

                                {/* Category */}
                                <div>
                                    <label className="block text-sm font-medium">Select Category</label>
                                    <select
                                        {...register("category")}
                                        className="mt-1 w-[98%] text-sm border rounded p-2 focus:outline-none "
                                    >
                                        <option value="" disabled hidden>
                                            Choose Category...
                                        </option>
                                        <option value="Graphs/Charts">Graphs/Charts</option>
                                        <option value="Forms">Forms</option>
                                        <option value="GenericUI">Generic UI</option>
                                        <option value="MediaView">MediaView</option>
                                        <option value="Navigation">Navigation</option>
                                        <option value="Resting Display">Resting Display</option>
                                        <option value="Others">Others</option>
                                    </select>
                                    {errors.category && (
                                        <p className="text-sm text-red-500">{errors.category.message}</p>
                                    )}
                                </div>

                                {/* Custom Category if Others */}
                                {category === "Others" && (
                                    <div>
                                        <input
                                            type="text"
                                            {...register("customCategory")}
                                            placeholder="Enter custom category..."
                                            className="mt-1 w-[98%] border rounded p-2 focus:outline-none text-sm "
                                        />
                                    </div>
                                )}

                                {/* Project Name */}
                                <div>
                                    <label className="block text-sm font-medium">Project Name</label>
                                    <input
                                        type="text"
                                        {...register("projectName")}
                                        placeholder="Enter Project Name..."
                                        className="mt-1 w-[98%] text-sm border rounded p-2 focus:outline-none "
                                    />
                                    {errors.projectName && (
                                        <p className="text-sm text-red-500">{errors.projectName.message}</p>
                                    )}
                                </div>

                                {/* Project Details */}
                                <div>
                                    <label className="block text-sm font-medium">
                                        Project Details<span className="text-red-500">*</span>
                                    </label>
                                    <textarea
                                        {...register("projectDetails", { required: "Project Details are required" })}
                                        placeholder="Enter Project Details..."
                                        className="mt-1 w-[98%] text-sm border rounded p-2 h-20 resize-none focus:outline-none "
                                    />
                                    {errors.projectDetails && (
                                        <p className="text-sm text-red-500">{errors.projectDetails.message}</p>
                                    )}
                                </div>

                                {/* Customer Name */}
                                <div>
                                    <label className="block text-sm font-medium">Customer Name</label>
                                    <input
                                        type="text"
                                        {...register("customerName")}
                                        placeholder="Enter Customer Name..."
                                        className="mt-1 w-[98%] text-sm border rounded p-2 focus:outline-none "
                                    />
                                    {errors.customerName && (
                                        <p className="text-sm text-red-500">{errors.customerName.message}</p>
                                    )}
                                </div>
                            </form>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end pt-4 space-x-2">
                            <button
                                type="button"
                                onClick={closePopup}
                                className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                onClick={handleSubmit(onSubmit)}
                                className="bg-[#1976d2] text-white px-4 py-2 rounded hover:bg-green-700"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddComponentForm;
